import DocumentSearchPage from "./DocumentSearchPage";

export default DocumentSearchPage;
